/**
 * Project dashboard
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api } from 'utils';

const defaultState = { item: null, errors: null };

const model = {
    name: 'account',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, item: payload }),
    },
    effects: {
        async fetch() {
            await api.get('account')
                .then(response => this.fetchResponse(response));
        },
    },
};

export default model;
